import { PasswordInput } from "@/app/components/PasswordInput";
import { LockClosedIcon, LockOpenIcon } from "@heroicons/react/16/solid";
import { CreateCourseDTO } from "@tumtutor/shared/dto";
import { SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface PasswordToggleProps {
  isPasswordProtected: boolean;
  course: CreateCourseDTO;
  setCourse: (value: SetStateAction<CreateCourseDTO>) => void;
}

const PasswordToggle = ({
  isPasswordProtected,
  course,
  setCourse,
}: PasswordToggleProps) => {
  const { t } = useTranslation(["courseManagementPage", "commons"]);
  const [overridePassword, setOverridePassword] = useState(false);
  const [passwordToggle, setPasswordToggle] = useState(false);

  useEffect(() => {
    setPasswordToggle(isPasswordProtected);
  }, [isPasswordProtected]);
  return (
    <div>
      <span className="label-text font-semibold text-lg">
        {t("passwordProtection")}
      </span>

      <div className="my-sm">
        <div className="mb-sm flex flex-row items-center">
          <input
            type="checkbox"
            className="toggle mr-md"
            checked={passwordToggle}
            onChange={(e) => {
              setPasswordToggle(e.target.checked);
              if (!e.target.checked) {
                setOverridePassword(false);
                setCourse((prev) => ({
                  ...prev,
                  password: null,
                }));
              }
            }}
          />
          {passwordToggle ? (
            <LockClosedIcon className="h-6 w-6" />
          ) : (
            <LockOpenIcon className="h-6 w-6 opacity-50" />
          )}

          <p
            className={`ml-sm font-semibold text-lg ${!passwordToggle ? "opacity-50" : ""}`}
          >
            {passwordToggle
              ? t("enabled", { ns: "commons" })
              : t("disabled", { ns: "commons" })}
          </p>
        </div>
        <div className="flex flex-row gap-x-2">
          {passwordToggle && isPasswordProtected && (
            <button
              type="button"
              className="btn btn-primary btn-xs"
              onClick={() => {
                if (overridePassword) {
                  setOverridePassword(false);
                  setCourse((prev) => ({
                    ...prev,
                    password: undefined,
                  }));
                } else {
                  setOverridePassword(true);
                }
              }}
            >
              {overridePassword
                ? t("cancel", { ns: "commons" })
                : t("changePassword")}
            </button>
          )}
        </div>
      </div>
      {passwordToggle && (
        <div>
          <div className="form-control w-full">
            {(!isPasswordProtected || overridePassword) && (
              <div className="max-w-xs">
                <PasswordInput
                  id="newPassword"
                  name="password"
                  required
                  value={course.password ?? ""}
                  onChange={(e) =>
                    setCourse((prev) => ({
                      ...prev,
                      password: e.target.value.replace(/\s/g, ""),
                    }))
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PasswordToggle;
